import {createContext} from 'react';

export const ReservationSourcesListContext = createContext({});
